import SubmittalLog from "./submittal-log";

function SubmittalLogLandingPage() {
  return <SubmittalLog />;
}

export default SubmittalLogLandingPage;
